module.exports = __webpack_public_path__ + "static/crop-bd12089c4b582356cd6c8b060189776e.mp4";